<template>
  <div class="">
    <div v-show="list.length > 0">
      <ul class="w1200">
        <li
          class="resource-item clearfix"
          v-for="(item, index) in list"
          :key="index"
        >
          <router-link
            :to="{
              path: '/project/detail',
              query: { id: item.id,type:item.type },
            }"
          >
            <div class="fl img-box">
              <img :src="item.coverUrl" />
            </div>
            <div class="fl right-cont">
              <p class="top-title oneline-ellipsis">{{ item.name }}</p>
              <div class="min-info clearfix">
                <p class="fl">作者：{{ item.author }}</p>
                <p class="fl">时间：{{ item.createTime }}</p>
                <p class="fl">浏览：{{ item.browseCount }}</p>
                <p class="fl">点赞：{{ item.likeCount }}</p>
              </div>
              <p class="content">
                <slice-num :text="item.intro" :num="140"></slice-num>
              </p>
              <div class="bottom clearfix" v-if="false">
                <ul class="label-list fl">
                  <li
                    class="fl"
                    v-for="(label, lIndex) in item.tagList"
                    :key="'label-' + lIndex"
                  >
                    #{{ label.name }}#
                  </li>
                </ul>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <no-data v-show="list.length === 0"></no-data>
  </div>
</template>
<script>
import noData from "../../components/noData/noData";
export default {
  props:{
    list: {
      type:Array,
      default:()=>[]
    },
    jumpurl:{
      type: String,
      default:'/'
    }
  },

  components: { noData },
};
</script>
<style lang="scss">
@import "./style/style.scss";
</style>

